import ImportAppConfig from './import/importAppConfig';
import ImportProductsAppConfig from './importProducts/ImportProductsAppConfig';

const ImportsAppConfig = [ImportAppConfig, ImportProductsAppConfig];

export default ImportsAppConfig;
